<template>
  <v-input
    :error="$errors.has('list_cell')"
    :error-messages="$errors.first('list_cell')"
    hide-details="auto"
  >
    <input
      v-show="false"
      v-validate="validate"
      :value="value"
      data-vv-as="«Выбрать колонку»"
      :name="listCell"
    >

    <v-btn
      :key="value"
      :disabled="disabled"
      depressed
      outlined
      @click="onSelectListCell"
      v-text="text"
    />
  </v-input>
</template>

<script>
import uniqueId from 'lodash/uniqueId'

import { createBEditorModalExcelCell } from '@/components/forms/BEditor/utils'
import { EXCEL_CELL_ERROR_LABEL } from '@/helpers/enums/params'


export default {
  name: 'FormTemplatesFormCellTypeListCell',
  inject: [
    '$validator',
  ],
  props: {
    value: String,
    skeleton: Boolean,
    disabled: Boolean,
    downable: Boolean,
    validate: {
      type: [String, Object],
    },
    sheetTree: {
      type: Object,
      required: true,
      validator: (prop) => (
        '$all_cells' in prop
      ),
    },
    currentSheet: {
      type: Object,
      required: true,
    },
    currentCell: {
      type: Object,
      required: true,
    },
  },
  computed: {
    text() {
      const { value } = this
      if (!value) return 'Выбрать колонку'
      const options = this.sheetTree.$all_cells.find((_) => _.uuid === value)
      if (!options) return EXCEL_CELL_ERROR_LABEL
      return `${options.$parent?.code}:${options.code}`
    },
    listCell() {
      return uniqueId('list_cell-')
    },
  },
  watch: {
    text: {
      immediate: true,
      handler(value) {
        if (value !== EXCEL_CELL_ERROR_LABEL) return
        this.$emit('input', null)
      },
    },
  },
  methods: {
    async onSelectListCell() {
      const propsData = {
        cell_uuid: this.value,
        sheetTree: this.sheetTree,
        currentSheet: this.currentSheet,
        currentCell: this.currentCell,
        active: true,
      }
      const modal = await createBEditorModalExcelCell(this, propsData)
      const result = await modal.open()

      if (!result) return
      this.$emit('input', result.cell_uuid[0])
    },
  },
}
</script>
